module.exports = __webpack_public_path__ + "static/media/page03_two_boys.6f8e76f8.gif";